// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style_disabled__3Lt6c"};